import { ApiMetadataRetriever } from "@mcleod/core";
import { ImageName } from "@mcleod/images";
import { DropdownSelectionEvent, LayoutProvidedTaskDecoratorProps, Textbox, TextboxProps } from "@mcleod/components";
import { AutogenLayoutMergeMasterCodes } from "./autogen/AutogenLayoutMergeMasterCodes";

const TASK_DESCRIPTION = "Replace Master Codes";

const LOOKUP_PROP_MAP: Record<string, Partial<TextboxProps>> = {
    "customer": {
        lookupModel: "lme/ar/customer-lookup",
        lookupModelLayout: "lme/ar/CustomerLookup",
        lookupModelResultField: "id",
        lookupModelDisplayField: "name",
        quickInfoLayout: "lme/ar/CustomerQuickInfo",
    },
    "location": {
        lookupModel: "lme/dispatch/location-lookup",
        lookupModelLayout: "lme/dispatch/LocationLookup",
        lookupModelResultField: "id",
        lookupModelDisplayField: "name",
        quickInfoLayout: "lme/dispatch/LocationQuickInfo",

    },
    "vendor": {
        lookupModel: "lme/settlement/vendor",
        lookupModelLayout: "lme/settlement/VendorLookup",
        lookupModelDisplayField: "vendor_name",
        lookupModelResultField: "id",
    },
    "users": {
        lookupModel: "common/users",
        lookupModelLayout: "common/UserLookup",
        quickInfoLayout: "common/UserQuickInfo",
        lookupModelResultField: "id",
        lookupModelDisplayField: "name"
    },
};

export class MergeMasterCodes extends AutogenLayoutMergeMasterCodes {
    override async onLoad(): Promise<void> {
        for (const props of Object.values(LOOKUP_PROP_MAP)) {
            await ApiMetadataRetriever.get(props.lookupModel);
        }
    }

    public override get taskDecoratorProps(): Partial<LayoutProvidedTaskDecoratorProps> {
        return {
            completionToastCondition: (response: any) => response != null,
            completionToastImageName: ImageName.circleConfirm,
            completionToastMessage: this.completionToastMessage,
            completionToastOptions: { persist: true },
            completionToastTitle: this.completionToastTitle,
            processLogDescription: TASK_DESCRIPTION
        };
    }

    private get completionToastTitle(): string {
        const codeType = this.textboxMasterTable.selectedItem?.displayValue;
        return `${codeType} Updated`;
    }

    private get completionToastMessage(): string {
        const oldCode = this.textboxOldCode.getFirstLookupModelData()?.get("id", "") ?? "";
        const newCode = this.textboxNewCode.getFirstLookupModelData()?.get("id", "") ?? "";
        return `${oldCode} was successfully replaced with ${newCode}.`
    }

    /** This is an event handler for the afterDropdownSelection event of textboxMasterTable. */
    textboxMasterTableAfterDropdownSelection(event: DropdownSelectionEvent): void {
        this.syncCodeTextbox(this.textboxOldCode, event.selection?.value);
        this.syncCodeTextbox(this.textboxNewCode, event.selection?.value);
    }

    private syncCodeTextbox(textbox: Textbox, newCode: string): void {
        textbox.clear();
        textbox.lookupModel = null;
        const lookupProps = LOOKUP_PROP_MAP[newCode];
        textbox.setProps(lookupProps ?? {});
    }
}
